import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'
import { AppLayout, AppContent } from '../../../styles/AppStyles'
import { SkeletonAppHeader } from './SkeletonAppHeader'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: ${SPACING.xl};
`

const Card = styled.div`
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
  padding: ${SPACING.xxl};
  width: 100%;
  max-width: 480px;
  box-shadow: var(--shadow-dropdown);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.lg};
`

export function SkeletonVote() {
  return (
    <AppLayout>
      <SkeletonAppHeader />
      <AppContent>
        <PageContainer>
          <Card>
            <SkeletonBox $width="160px" $height="26px" $radius={BORDER_RADIUS.lg} />
            <SkeletonBox $width="240px" $height="16px" $radius={BORDER_RADIUS.sm} />
            <SkeletonBox $width="100%" $height="50px" $radius={BORDER_RADIUS.lg} />
            <SkeletonBox $width="100%" $height="48px" $radius={BORDER_RADIUS.lg} />
          </Card>
        </PageContainer>
      </AppContent>
    </AppLayout>
  )
}
